import Language from '../types/language';

const useLanguages = () => {
  const languages: Record<string, Language> = {
    en: { id: 'en', name: 'English' },
    de: { id: 'de', name: 'Deutsch' },
    nl: { id: 'nl', name: 'Nederlands' },
    fr: { id: 'fr', name: 'Français' },
    pl: { id: 'pl', name: 'Polski' },
    es: { id: 'es', name: 'Español' },
    et: { id: 'et', name: 'Eesti' },
    bg: { id: 'bg', name: 'български' },
    sl: { id: 'sl', name: 'Slovenščina' },
    it: { id: 'it', name: 'Italiano' },
    sk: { id: 'sk', name: 'Slovenština' },
    ru: { id: 'ru', name: 'Русский' },
    hu: { id: 'hu', name: 'Magyar nyelv' },
    pt: { id: 'pt', name: 'Português' },
    ro: { id: 'ro', name: 'Română' },
  };

  return languages;
};

export default useLanguages;
